'use client';

import { createContext, useContext, useEffect } from 'react';
import { setBrowserTenantId } from '@/lib/supabase/browser-tenant';

const TenantIdContext = createContext<string | null>(null);

export function TenantProvider({
  tenantId,
  children,
}: {
  tenantId: string;
  children: React.ReactNode;
}) {
  // Set tenant ID on the browser Supabase client so RLS works
  useEffect(() => {
    setBrowserTenantId(tenantId);
  }, [tenantId]);

  return (
    <TenantIdContext.Provider value={tenantId}>
      {children}
    </TenantIdContext.Provider>
  );
}

/**
 * Get the current tenant ID in a client component.
 * The TenantProvider must be mounted above this component.
 */
export function useTenantId(): string {
  const id = useContext(TenantIdContext);
  if (!id) throw new Error('useTenantId: TenantProvider not found');
  return id;
}
